export default {
    abonplata: "Абонентская плата",
    absent: "Отсутствует",
    access_restriction: "Ограничение доступа",
    accountant_fio: "ФИО главного бухгалтера",
    accrue_bonuses_on_bonus_payments: "Начислять бонусы на оплату бонусами",
    acquiring_fee: "% эквайринга",
    activate_bonus_system: "Активировать бонусную систему",
    add_field: "Добавить направление",
    add_user: "Добавить пользователя",
    additional_doctors: "Дополнительно врачей",
    additional_green_api: "Дополнительно Green API",
    additional_green_api_max: "Дополнительно Green API Max",
    additional_green_api_telegram: "Дополнительно Green API Telegram",
    additional_jet_api: "Дополнительно JET API",
    additional_modules: "Дополнительные модули",
    additional_partner_api: "Дополнительно партнерский api",
    additional_space: "Дополнительное место",
    admins_limit: "Лимит администраторов",
    Advance: "Депозит",
    advance_calculated: "Депозит",
    advance_payment: "Единоразовый платеж",
    after_discounts: "После учета скидок",
    after_technic_deduction: "После вычета техника",
    after_visit: "Напоминание после визита",
    after_visit_day_passed: "После визита (сразу)",
    AgreementDocument: "Шаблон согласия",
    akt_text: "Пометка в акте оказанных услуг",
    all_administrators: "Все администраторы",
    all_rights: "Все права",
    all_visits: "Все записи",
    allow: "Разрешить",
    allow_negative_deposits: "Разрешать списание депозитов в минус",
    allow_opening_several_visits_at_the_same_time: "Разрешить открытие нескольких визитов одновременно",
    allowed_ips: "IP адреса, с которых возможен вход в аккаунт",
    api: "API",
    api_token: "API токен",
    are_you_sure_you_want_to_delete_branch: "Вы уверены, что хотите удалить филиал?",
    are_you_sure_you_want_to_delete_company: "Вы уверены, что хотите удалить компанию?",
    are_you_sure_you_want_to_delete_notification: "Вы уверены, что хотите удалить уведомление?",
    are_you_sure_you_want_to_delete_source: "Вы уверены, что хотите удалить источник?",
    are_you_sure_you_want_to_delete_tag: "Вы уверены, что хотите удалить метку?",
    ask_for_more: "Запросить еще",
    ask_reason_cancel: "Запрашивать причину отмены визита",
    ask_reason_not_come: "Запрашивать причину при статусе 'не пришел'",
    ask_reason_reschedule: "Запрашивать причину переносе визита",
    assistants_connected: "Подключен модуль Ассистенты",
    automatic_conflict_task_creation: "Автоматическое создание задач при конфликте расписания",
    available_disk_space: "Доступное место на диске, МБ (0 - безлимит)",
    before_discounts: "До учета скидок",
    before_technic_deduction: "До вычета техника",
    before_visit: "Напоминание перед визитом",
    before_visit_day_in_advance: "Напоминание о визите за день (сразу)",
    billing: "Биллинг",
    billing_payment: "Оплата",
    billing_turned_off: "Биллинг отключен",
    bonus: "Бонус",
    bonus_accrued: "Начислено бонусов",
    bonus_adjustment: "Корректировка бонусов",
    bonus_payment: "Оплата бонусом",
    bonus_percent_can_be_used: "Максимальная доля продажи, которую можно оплатить бонусами",
    bonus_percent_of_cheque: "Процент бонусов от продажи",
    bonus_system: "Бонусная система",
    bonuses: "Бонусы",
    bonuses_payment: "Оплата бонусами",
    branch_address: "Адрес филиала",
    branch_contacts: "Контакты филиала",
    branch_inn: "ИНН филиала",
    branches: "Филиалы",
    branches_connected: "Подключен платный модуль Филиалы",
    by_chairs: "По креслам",
    calendar_text_color: "Цвет текста в календаре",
    calendar_view_by_default: "Вид календаря по умолчанию",
    cancel_and_move_reason: "Причина отмен и переносов",
    cancel_and_move_reasons: "Причины отмен и переносов",
    change_tariff: "Сменить тариф",
    cities: "Города",
    city: "Город",
    client_tag: "Метка",
    ClientDocument: "Документ пациента",
    ClientNote: "Примечание",
    ClientTag: "Тег пациента",
    clinic: "Клиника",
    clinic_data: "Данные клиники",
    clinic_inn: "ИНН клиники",
    clinic_is_blocked: "Клиника заблокирована",
    clinic_name: "Название клиники",
    clinic_name_in_cheque: "Название клиники в чеке",
    ClinicAdditional: "Доп. настройки клиники",
    clinics: "Клиники",
    ClinicTariff: "Тариф клиники",
    close: "Закрыть",
    cloud_space: "Место в облаке",
    communications: "Коммуникации",
    company_data: "Данные компании",
    ComplexService: "Комплексная услуга",
    configuration: "Конфигурация",
    connected_successfully: "Подключено успешно",
    connection_failed: "Ошибка связи",
    control_system: "Система контроля",
    countries: "Страны",
    country: "Страна",
    crm_application_created: "Создание заявки CRM",
    crm_connected: "Подключен платный модуль CRM",
    Curator: "Куратор",
    currency_rates: "Курсы валют",
    CustomRole: "Роль",
    data: "Данные",
    date_of_registration: "Дата регистрации",
    day: "День",
    deduct_acquiring_from_salary: "Вычитать эквайринг из зарплат",
    deduct_warranty_from_salary: "Не начислять зарплату сотрудникам по гарантийному случаю",
    deleted: "Удаление",
    demo: "Демо",
    dentist_plus: "Dentist plus",
    DepositByAccount: "Депозит по счёту",
    PayMethod: "Способ оплаты",
    PayMethodCustomData: "Настройки способа оплаты",
    diagnosis_dictionary: "Справочник диагнозов",
    director_data: "Данные руководителя",
    director_fio: "ФИО директора",
    disk_space_limit: "Лимит дискового места (Мб)",
    do_not_deduct_acquiring_from_technic_absolute: "Не вычитать эквайринг у техников с абсолютным начислением",
    do_not_send_notifications_if_period_passed: "Не отправлять напоминание о визите, если срок уже прошёл",
    do_not_show: "Не показывать",
    Doctor: "Врач",
    'doctor-services': "Врач - услуги",
    DoctorAssistant: "Ассистент",
    doctors_limit: "Лимит врачей",
    DoctorScheduleConfiguration: "Настройка расписания врача",
    DogovorDocument: "Шаблон договора",
    DynamicConfig: "Конфигурация",
    egisz_prod: "ЕГИСЗ в боевом режиме",
    EGISZRecord: "Отправка в ЕГИСЗ",
    enter_ip_address: "Введите IP-адрес",
    error_code: "Код ошибки",
    field_configuration_in_diary: "Настройка полей в дневнике",
    field_configuration_in_teeth_general: "Настройка общих полей во вкладке зубы",
    field_configurations_in_description: "Настройка полей в описании",
    field_configurations_in_teeth: "Настройка полей в зубах",
    finance: "Финансы",
    free: "Свободно",
    free_day: "Бесплатный день",
    general: "Общее",
    GeneratedDocument: "Сформированный документ",
    has_additional_doctors: "Есть дополнительные врачи",
    higher_number_higher_priority: "Чем выше номер, тем выше опция в списке",
    hour: "час",
    hours: "часы",
    image_hidden: "Изображение скрыто",
    in_development: "В разработке",
    insurance_company: "Страховая компания",
    integrations: "Интеграции",
    interface: "Интерфейс",
    ioka: "Ioka",
    ip_note: "Будьте внимательны при вводе IP - адреса, чтобы не потерять доступ к программе. Можно использовать только в случае, если у Вас статический IP адрес в клинике.",
    jetapi_connected: "Подключен модуль JET API",
    'kit materials sync': "Привязка материалов к комплекту",
    kpp: "КПП",
    last_login: "Последний вход",
    legal_address: "Юридический адрес",
    legal_name: "Юридическое название",
    license: "Лицензия",
    license_issue_body: "Кем выдана лицензия",
    license_issue_date: "Дата выдачи лицензии",
    license_num: "Лицензия #",
    location_on_map: "Местоположение на карте",
    logo: "Логотип",
    logout_interval_timeout: "Интервал выхода из программы при отсутствии активности (для учётных записей администраторов)",
    logs: "Логи",
    logs_journal: "Журнал действий",
    Manager: "Администратор",
    manager2: "Менеджер",
    manual: "Ручная",
    max_doctor_amount: "Максимальное кол-во докторов",
    max_qr_instructions: "На телефоне в приложении Max считайте qr код",
    min: "минут",
    min_symbols: "Минимум символов",
    minute: "минута",
    minutes: "минут",
    model_id: "Id модели",
    model_type: "Тип модели",
    month: "Месяц",
    monthly_payment: "Месячный платеж",
    months_to_consider_patient_lost: "Кол-во месяцев, после которых пациент считается утерянным",
    more_than_one_day: "Более одного дня",
    more_than_one_visit: "Более одного визита",
    next_payment: "Следующий платеж",
    not_connected: "Не подключено",
    notification_channel: "Тип доставки",
    notification_setting: "Уведомление",
    notification_type: "Тип уведомления",
    notifications: "Уведомления",
    NotificationSetting: "Уведомление",
    NotificationWaitingResponse: "Ожидание подтверждения в сообщении",
    occupied: "Занято",
    of_few_hours: "часа",
    ogrn: "ОГРН",
    oid_ministry_rf: "OID Министерства здравоохранения РФ",
    on: "Включено",
    on_pay_page: "На страницу оплаты",
    online_booking: "Онлайн-запись",
    online_booking_activate: "Активировать онлайн-запись",
    online_booking_categories: "Отображать категории услуг",
    online_booking_feedbacks: "Активировать функционал отзывов",
    online_booking_map: "Отображать карту филиала",
    online_booking_max_days: "Максимальный период записи в днях",
    online_booking_path: "Путь пациента в онлайн записи",
    online_booking_time: "Бронировать время в календаре или нет",
    only_after_accordance_with_trustme: "Только после согласования с trustme.kz",
    only_after_payment_received: "Только при получении оплаты от пациента",
    paid_functionality: "Оплачиваемый функционал",
    paid_till: "Оплачено до",
    paid_with_bonus: "Оплачено бонусами",
    partner_api_limit: "Бесплатный лимит партнерского api",
    Patient: "Пациент",
    patient_conditions: "Состояния пациентов",
    patient_sources: "Источники пациентов",
    PatientComment: "Комментарий пациента",
    patients_import: "Импорт пациентов",
    pay: "Оплатить",
    pay_methods: "Способы оплаты",
    pay_methods_acquiring: "Способы оплат для передачи на эквайринг-терминал",
    pay_methods_cash: "Способы оплаты, отображающиеся как наличные",
    pay_system: "Платежная система",
    payable: "Платный",
    Payment: "Оплата",
    payment_id: "Id оплаты",
    percent_accrual_for_administrator: "Начисление процента администраторам",
    percent_accrual_for_personnel: "Начисление процента персоналу",
    period_by_default: "Период по умолчанию",
    permanent_patients_hint: "Считать ли пациента постоянным при а) наличии у него минимум двух визитов со статусом пришел или услугами в счете, даже в течение одного дня  б) наличии у него минимум двух разных дней с визитами",
    plan_treatment_text: "Пометка в плане лечения",
    PlanSession: "Этап плана лечения",
    PlanTreatment: "План лечения",
    popup: "Попап",
    Price: "Позиция прайса",
    price_per_additional_doctor: "Цена за дополнительного врача",
    price_per_additional_partner_api: "Цена за дополнительный партнерский api",
    price_per_additional_space: "Цена за дополнительное место (100 Мб)",
    program_language: "Язык программы",
    prolong: "Продлить",
    purchase: "Покупка",
    recipient: "Получатель",
    Record: "Запись",
    record_tag: "Ярлык для визитов",
    record_tags: "Ярлыки для визитов",
    record_timing_enabled: "Система контроля 'Начало и завершения визитов'",
    record_types: "Типы записей",
    RecordTooth: "Зуб",
    reject: "Отклонить",
    required_fields_to_close_visit: "Обязательные поля для закрытия визита",
    requires_payment: "Требует доплаты",
    reset_verb: "Сбросить",
    right: "Право",
    rights: "Права",
    salary_accrual: "Логика начисления процентов врачам / администраторам / кураторам",
    salary_accrual_for_personnel: "Начисление зарплаты врачам / администраторам / кураторам",
    salary_accrual_for_personnel_with_assistants: "Начисление зарплаты врачам / администраторам / кураторам / ассистентам",
    salary_accrual_for_technics: "Начисление зарплаты техникам",
    salary_accrual_with_assistants: "Логика начисления процентов врачам / администраторам / кураторам / ассистентам",
    save_settings: "Сохранить настройки",
    Scan: "Скан",
    send_time: "Время отправки",
    sending_after_save_or_finish: "Запрашивать результат визита / отправку документа в ЕГИСЗ при нажатии:",
    sendouts_only_in_day_time: "Отправлять массовые рассылки  в дневное время (09.00 - 22.00)",
    server_error: "Системе не удалось выполнить ваш запрос. Пожалуйста, повторите попытку или обратитесь в службу поддержки",
    services_import: "Импорт услуг",
    'services-doctor': "Услуги - врач",
    short_title: "Сокращенное название",
    show_complex_materials_for_teeth: "Отображать комплекты и материалы во вкладке \"Зубы\" в Карточке лечения",
    show_description_in_forms: "Отображать комментарий к визиту в формат 043, 058, истории лечения",
    show_doctor_in_documents: "Отображать врача при печати документов",
    show_images: "Показывать изображения",
    show_preinstalled_templates: "Показывать предустановленные шаблоны",
    show_service_classificator_data_in_documents: "Использовать код и название услуги в печатных документах из классификатора",
    show_teeth_general: "Отображать общие поля во вкладке \"Зубы\" в Карточке лечения",
    sign_type: "Тип подписи",
    sort_order: "Порядок отображения",
    source: "Источник",
    sources: "Источники",
    StaffWork: "Работа сотрудника",
    super_user: "Суперпользователь",
    superadmin: "Суперадминистратор",
    superadministrators: "Суперадминистраторы",
    supermanager: "Суперменеджер",
    SuperManager: "Администратор",
    switched_to_version_2: "Перешла на версию 2.0",
    sync_data: "Синхронизировать данные",
    table_settings: "Настройки таблицы",
    tag: "Ярлык",
    tag_id: "Метка",
    tags: "Метки",
    tags_for_custom_notifications: "Тэги для автоматического вывода информации:",
    tags_for_notifications: "Тэги для автоматического вывода информации:",
    tariff: "Тариф",
    tariff_payment_expires_in_days: "Оплата по тарифу заканчивается сегодня | Оплата по тарифу заканчивается через {day} день | Оплата по тарифу заканчивается через {day} дня",
    tariffs: "Тарифы",
    task_created: "Создание задачи",
    Technic: "Техник",
    technic_salary_accrual: "Логика начисления процентов техникам",
    techsupport_panel: "Панель техподдержки",
    templates: "Шаблоны",
    templates_agreements: "Шаблоны согласий",
    templates_categories: "Стандартные категории",
    templates_contracts: "Шаблоны договоров",
    templates_for_fields: "Шаблоны для полей",
    templates_text: "Текстовые шаблоны",
    templates_treatments: "Шаблоны лечений",
    test: "Тест",
    this_may_take_several_minutes_do_not_close_the_window: "Это может занять несколько минут. Не закрывайте окно",
    time_after_visit: "после визита",
    time_before_visit: "до визита",
    time_interval_value: "Величина интервалов времени",
    time_zone: "Часовой пояс",
    to_billing: "К настройкам биллинга",
    to_the_one_who_accepted_payment: "Тому, кто принимает платеж",
    to_the_one_who_made_record: "Тому, кто делает запись",
    top: "Топ",
    treatment_finished: "Лечение завершено",
    turn_off: "Отключить",
    turn_on_autosign: "Включить автоподписание",
    turned_off: "Выключена",
    turned_on: "Включена",
    ukrainian: "Украинский",
    unblock_for_3_days: "Разблокировать на 3 дня",
    updated: "Изменено",
    use_bonuses_on_salary: "Начисление зарплаты с оплаты бонусами",
    use_proxy: "Использовать прокси",
    User: "Пользователь",
    user_id: "Id пользователя",
    UserAdditional: "Доп. данные пользователя",
    uzbek: "Узбекский",
    verify: "Верифицировать",
    'visit services sync': "Привязка услуг",
    'visit diagnoses sync': "Привязка диагнозов",
    visit_cancel: "Отмена визита",
    visit_comment: "Комментарий к визиту",
    visit_created: "Создание визита",
    visit_result: "Результат визита",
    visit_results: "Результаты визита",
    visit_type: "Вид приема",
    warehouse_connected: "Подключен платный модуль склад",
    WarehouseInventarizationSheet: "Инвентаризационная ведомость",
    WarehouseOperation: "Складская операция",
    week: "Неделя",
    when_changing_tariff_all_payments_will_nullify: "При смене тарифа все платежи будут аннулированы",
    which_branches_use_online_booking: "Какие филиалы используют онлайн-запись",
    which_clients_to_consider_permanent: "Каких клиентов считать постоянными",
    work_time_from: "Время работы с",
    work_time_to: "Время работы до",
    your_current_ip: "Ваш текущий IP",
    your_tariff_plan_is_not_paid: "Ваш тарифный план не оплачен",
    zero_unlimited: "0 - неограниченно"
}
